import JSONbig from 'json-bigint';

// 配置json-bigint，将大整数转换为字符串
const JSONbigString = JSONbig({
  storeAsString: true,
  useNativeBigInt: false
});

/**
 * 大数字精度处理工具函数
 */

/**
 * 安全地将值转换为字符串，避免精度丢失
 * @param {*} value - 要转换的值
 * @returns {string} - 字符串形式的值
 */
export function safeToString(value) {
  if (value === null || value === undefined) {
    return String(value);
  }

  // 如果已经是字符串，直接返回
  if (typeof value === 'string') {
    return value;
  }

  // 如果是BigInt，转换为字符串
  if (typeof value === 'bigint') {
    return value.toString();
  }

  // 如果是数字且可能存在精度问题（大于安全整数范围）
  if (typeof value === 'number') {
    if (Number.isSafeInteger(value)) {
      return value.toString();
    } else {
      console.warn(`数字 ${value} 可能存在精度丢失问题，建议使用字符串形式传递`);
      return value.toString();
    }
  }

  return String(value);
}

/**
 * 安全地比较两个可能是大数字的值
 * @param {*} a - 第一个值
 * @param {*} b - 第二个值
 * @returns {boolean} - 是否相等
 */
export function safeEquals(a, b) {
  // 将两个值都转换为字符串进行比较
  const strA = safeToString(a);
  const strB = safeToString(b);
  return strA === strB;
}

/**
 * 检查一个数字是否可能存在精度问题
 * @param {*} value - 要检查的值
 * @returns {boolean} - 是否可能存在精度问题
 */
export function isPotentiallyUnsafe(value) {
  if (typeof value !== 'number') {
    return false;
  }
  return !Number.isSafeInteger(value);
}

/**
 * 安全地解析JSON，处理大数字精度问题
 * @param {string} jsonString - JSON字符串
 * @returns {*} - 解析后的对象
 */
export function safeJSONParse(jsonString) {
  try {
    return JSONbigString.parse(jsonString);
  } catch (error) {
    console.error('JSON解析失败:', error);
    try {
      console.warn('回退到原生JSON.parse解析');
      return JSON.parse(jsonString);
    } catch (fallbackError) {
      console.error('原生JSON.parse解析失败:', fallbackError);
      throw error;
    }
  }
}

/**
 * 安全地序列化对象为JSON，处理大数字
 * @param {*} obj - 要序列化的对象
 * @returns {string} - JSON字符串
 */
export function safeJSONStringify(obj) {
  return JSON.stringify(obj, (key, value) => {
    // 如果值是数字且可能不安全，转换为字符串
    if (typeof value === 'number' && !Number.isSafeInteger(value)) {
      console.warn(`属性 ${key} 的值 ${value} 可能存在精度问题，已转换为字符串`);
      return value.toString();
    }
    return value;
  });
}
